/**
 * Blog Post Process Handlers
 *
 * All blog post-related query handlers
 */

import { handleRequest } from './config'
import { ApiResponse } from '../types'
import { httpsCallable } from 'firebase/functions'
import { functions } from '../../libs/Firebase'
import { BlogPost } from '../../../../pure-js/types/BlogPost'
import type { GetBlogPostsRequest, GetBlogPostsResponse } from '../types/blogPosts'

// ========================================
// QUERY HANDLERS
// ========================================

/**
 * Get blog posts
 * Optionally filter by language and type
 * Public access - no authentication required for viewing
 */
export const getBlogPosts = async (request: GetBlogPostsRequest = {}): Promise<ApiResponse<BlogPost[]>> => {
  return handleRequest(
    () => Promise.resolve({ data: [], success: true } as ApiResponse<BlogPost[]>),
    async () => {
      try {
        const callable = httpsCallable<GetBlogPostsRequest, GetBlogPostsResponse>(functions, 'getBlogPosts')
        const result = await callable(request)

        if (!result.data.success) {
          const errorMessage = result.data.error || 'Failed to fetch blog posts from backend'
          throw new Error(errorMessage)
        }

        if (!result.data.posts) {
          return {
            data: [],
            success: true
          }
        }

        return {
          data: result.data.posts,
          success: true
        }
      } catch (error: unknown) {
        // Re-throw so React Query can handle it properly
        if (error instanceof Error) {
          throw error
        }
        throw new Error('Unknown error occurred while fetching blog posts')
      }
    }
  )
}
